<template>
    <header class="navbar">
        <div class="nav-container">
            <!-- 左侧 Logo -->
            <div class="logo">
                <a href="/">
                    <img src="../assets/images/logo/logo.png" alt="SXVE-AI" />
                </a>
            </div>

            <!-- 中间导航菜单 -->
            <ul class="nav-links">
                <li v-for="item in menuItems" :key="item.name" class="nav-item">
                    <!-- 有子菜单的情况 -->
                    <a v-if="item.children" href="javascript:void(0);" class="dropdown-trigger">
                        {{ item.name }} <i class="fas fa-chevron-down"></i>
                    </a>
                    <!-- 聊天项：不跳转路由，打开 Crisp -->
                    <a v-else-if="item.isChat" href="javascript:void(0);" @click.prevent="openChat">
                        {{ item.name }}
                    </a>
                    <!-- 普通菜单项 -->
                    <a v-else @click.prevent="jumpPage(item.link)" href="javascript:void(0);">
                        {{ item.name }}
                    </a>

                    <!-- 二级下拉菜单 -->
                    <ul v-if="item.children" class="submenu">
                        <li v-for="child in item.children" :key="child.name">
                            <a @click.prevent="jumpPage(child.link)" href="javascript:void(0);">
                                {{ child.name }}
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>

            <!-- 右侧语言切换 -->
            <div class="nav-icons">
                <div class="lang-dropdown" @click="toggleLangMenu">
                    <i class="fas fa-globe"></i>
                    <div v-show="isLangMenuOpen" class="lang-menu">
                        <a href="#">English</a>
                        <a href="#">Español</a>
                        <a href="#">Français</a>
                        <a href="#">Русский язык</a>
                    </div>
                </div>
            </div>

            <!-- 移动端汉堡菜单按钮 -->
            <div class="hamburger" @click="toggleMobileMenu">
                <i class="fas fa-bars"></i>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Navbar',
    data() {
        return {
            menuItems: [
                { name: 'Home', link: '/' },
                {
                    name: 'Company',
                    children: [
                        { name: 'What kind of company is SXVE-AI?', link: '/company/index' },
                        { name: 'What are the main businesses of SXVE-AI?', link: '/company/businessservice' },
                        { name: 'The background of SXVE-AI', link: '/company/background' },
                    ]
                },
                {
                    name: 'Robotics',
                    children: [
                        { name: 'AI-1', link: '/robotics/education' },
                        { name: 'AI-2', link: '/robotics/base' },
                        { name: 'AI-3', link: '/robotics/restaurant' },
                        { name: 'XPRO-1', link: '/company/businessservice' },
                        { name: 'XPRO-2', link: '/robotics/highservice' },
                        { name: 'XPRO-3', link: '/robotics/industrial' },
                        { name: 'XPRO-4', link: '/robotics/large-automation' },
                        { name: 'XPRO-5', link: '/robotics/humanoidrobot' },
                        { name: 'XPRO-6', link: '/robotics/medicalrobot' }
                    ]
                },
                { name: 'Application Scenarios', link: '/robot-introduction' },
                { name: 'Solutions', link: '/solutions' },
                {
                    name: 'FAQ',
                    children: [
                        { name: 'About Platform', link: '/faq/platform' },
                        { name: 'Common Doubts', link: '/faq/question' }
                    ]
                },
                // 👇 新增 Contact us 菜单项（打开聊天室）
                { name: 'Contact us', isChat: true }
            ],
            isLangMenuOpen: false,
            isMobileMenuOpen: false
        };
    },
    methods: {
        toggleLangMenu() {
            this.isLangMenuOpen = !this.isLangMenuOpen;
        },
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
            const navLinks = document.querySelector('.nav-links');
            if (navLinks) {
                if (this.isMobileMenuOpen) {
                    navLinks.classList.add('active');
                } else {
                    navLinks.classList.remove('active');
                }
            }
        },
        jumpPage(link) {
            this.$router.push({ path: link });
            this.isMobileMenuOpen = false;
        },
        // 打开 Crisp 聊天室
        openChat() {
            if (window.$crisp) {
                window.$crisp.push(['do', 'chat:open']);
            } else {
                // 如果脚本尚未加载，等待 500ms 重试
                setTimeout(() => {
                    if (window.$crisp) {
                        window.$crisp.push(['do', 'chat:open']);
                    } else {
                        console.warn('Crisp not loaded');
                    }
                }, 500);
            }
        }
    },
    mounted() {
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.lang-dropdown')) {
                this.isLangMenuOpen = false;
            }
        });
    }
};
</script>

<style scoped>
/* 你的原有样式全部保留，无需改动 */
.navbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding: 8px 24px;
    box-sizing: border-box;
}

.nav-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
}

.logo img {
    width: 60px;
    display: block;
}

.nav-links {
    display: flex;
    align-items: center;
    gap: 28px;
    list-style: none;
    margin: 0;
    padding: 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
}

.nav-item {
    position: relative;
    list-style: none;
    white-space: nowrap;
    /* 强制不换行 */
}

.nav-item>a {
    color: #1d1d1f;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    padding: 12px 0;
    display: inline-block;
    transition: color 0.2s;
    cursor: pointer;
}

.nav-item>a:hover {
    color: #0066cc;
}

.dropdown-trigger i {
    font-size: 12px;
    margin-left: 4px;
}

.submenu {
    position: absolute;
    top: 100%;
    left: 0;
    background-color: white;
    border-radius: 12px;
    padding: 12px 0;
    min-width: 220px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
    opacity: 0;
    visibility: hidden;
    transition: all 0.2s ease;
    list-style: none;
    border: 1px solid #eaeaea;
    z-index: 1001;
}

.nav-item:hover .submenu {
    opacity: 1;
    visibility: visible;
}

.submenu li a {
    display: block;
    padding: 8px 20px;
    color: #1d1d1f;
    text-decoration: none;
    font-size: 13px;
    transition: background 0.2s;
}

.submenu li a:hover {
    background-color: #f5f5f7;
}

.nav-icons {
    position: relative;
    cursor: pointer;
}

.lang-dropdown {
    position: relative;
}

.lang-dropdown i {
    font-size: 18px;
    color: #1d1d1f;
}

.lang-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    border-radius: 12px;
    padding: 12px 0;
    min-width: 140px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
    border: 1px solid #eaeaea;
    z-index: 1001;
    margin-top: 8px;
}

.lang-menu a {
    display: block;
    padding: 8px 20px;
    color: #1d1d1f;
    text-decoration: none;
    font-size: 13px;
    transition: background 0.2s;
}

.lang-menu a:hover {
    background-color: #f5f5f7;
}

.hamburger {
    display: none;
    font-size: 24px;
    cursor: pointer;
    color: #1d1d1f;
}

@media (max-width: 1024px) {
    .nav-links {
        position: fixed;
        top: 60px;
        left: -100%;
        width: 100%;
        height: calc(100vh - 60px);
        background-color: white;
        flex-direction: column;
        align-items: flex-start;
        padding: 40px 24px;
        gap: 20px;
        transition: left 0.3s ease;
        transform: none;
        z-index: 999;
        overflow-y: auto;
    }

    .nav-links.active {
        left: 0;
    }

    .nav-item {
        width: 100%;
    }

    .submenu {
        position: static;
        opacity: 1;
        visibility: visible;
        box-shadow: none;
        padding-left: 20px;
        background-color: transparent;
        margin-top: 8px;
        border: none;
    }

    .hamburger {
        display: block;
    }

    .nav-icons {
        margin-right: 50px;
    }
}
</style>